<template lang="pug">
  .content
    swiper.swiper(:options='swiperOption' :breakpoints='swiperOption.breakpoints' :pagination='{"clickable": true}' @slideChange='changeSwiperIndex' ref='mySwiper')
      //- .swiper-button-prev(slot="button-prev" v-if="data.length > 1")
      .swiper-pagination(slot='pagination' v-if="data.length > 1")
      //- .swiper-button-next(slot="button-next" v-if="data.length > 1")
      swiper-slide(v-for="(i, idx) in slideData" :key="idx")
        img(:src='i.file_src' alt='')
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  name: 'Content',
  props: {
    data: Array,
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 40,
        // slidesPerView: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        effect: 'slide',
        loop: false,
        breakpoints: {
          1320: {
            spaceBetween: 0,
            slidesPerView: 1,
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 1,
            // loop: true,
          },
        },
        // autoplay: {
        //   delay: 3500, // 시간 설정
        //   disableOnInteraction: false, // false로 설정하면 스와이프 후 자동 재생이 비활성화 되지 않음
        // },
      },
      activeIdx: 0,
      slideData: [],
    };
  },
  computed: {},
  methods: {
    changeSwiperIndex() {
      this.activeIdx = this.$refs.mySwiper.swiperInstance.realIndex;
    },
    popData() {
      this.slideData.splice(this.activeIdx, 1);
    },
  },
  created() {
    this.slideData = this.data;
  },
  mounted() {},
};
</script>

<style scoped>
.modal-title {
  margin-bottom: 10px;
}
h1 {
  font-size: 20px;
  font-family: 'Noto Sans Korean', sans-serif;
}
h2 {
  font-family: 'Noto Sans Korean', sans-serif;
}
div {
  font-family: 'Noto Sans Korean', sans-serif;
}
.swiper-pagination {
  top: 50px;
  /* margin-left: 80%;
  width: auto !important; */
}
.swiper {
  height: 550px;
  /* height: 470px; */
}

@media (max-width: 768px) {
  .swiper .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0;
    top: 0;
  }
  .swiper-pagination {
    margin-left: 80%;
    width: auto !important;
  }
}
</style>
